import React from "react"

interface KeyIconProps {
	className: string
}

export function KeyIcon({className}: KeyIconProps) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" className={className}>
			<path
				fill="#fff"
				d="M20.42 3.83a7.312 7.312 0 0 0-12.089 7.543l-5.26 5.26a1.308 1.308 0 0 0-.384.927v2.69A1.313 1.313 0 0 0 4 21.563h3A.563.563 0 0 0 7.563 21v-1.688H9.25a.563.563 0 0 0 .563-.562v-1.688H11.5a.56.56 0 0 0 .398-.165l.98-.978a7.275 7.275 0 0 0 2.372.393h.01A7.312 7.312 0 0 0 20.42 3.83Zm1.017 5.373c-.105 3.296-2.875 5.98-6.176 5.985a6.18 6.18 0 0 1-2.298-.438.562.562 0 0 0-.622.118l-1.074 1.07H9.25a.562.562 0 0 0-.563.562v1.688H7a.562.562 0 0 0-.563.562v1.688H4a.188.188 0 0 1-.188-.188v-2.69c0-.05.02-.097.055-.132l5.515-5.515a.563.563 0 0 0 .118-.623 6.151 6.151 0 0 1-.438-2.297c0-3.301 2.69-6.072 5.985-6.18a6.188 6.188 0 0 1 6.39 6.39Zm-3.375-2.078a.938.938 0 1 1-1.875 0 .938.938 0 0 1 1.875 0Z"
			/>
		</svg>
	)
}
